import axios from '@/api/axios'

export default {
    // 保存聊天
    imSaveChat: (params) => axios.post('api/v1/system/im/chat', params),

    // 游客获取im聊天
    imAccount: (params) => axios.get('/b/base/v1/visitor/imAccount', params),
}
